import { useState, useEffect, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useBlogContext } from "../../../context/BlogContext"
import useForm from "../../../hooks/useForm"
import { BlogI } from "../../../models/blog"
import { BlogImagesI, addBlog, updateBlog, checkSlugExists } from "../../../services/blog"
import { generateSlug, isNewRegister } from "../../../utils/strings"
import { Timestamp } from "firebase/firestore"


const initialStateValues = {
  img_portada: '',
  titulo: '',
  descripcion_breve: '',
  contenido: '',
  img_thumb: '',
  slug: '',
  img_contenido: '',
  img_destacada: '',
  destacado: false,
  categorias: '',
  restringido: false,
  path_img_thumb:"",
  path_img_destacada:"",
  path_img_contenido:""
}

const useBlogAdd = (blog?: BlogI) => {

  const [images, setImages] = useState<BlogImagesI>({
    imgThumb: undefined,
    imgContenido: undefined,
    imgPortada: undefined
  })
  const [slugManuallyEdited, setSlugManuallyEdited] = useState(!!blog?.slug)
  const [slugError, setSlugError] = useState<string | null>(null)
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const navigate = useNavigate()
  const { setBlogs } = useBlogContext()
  const { onChange: baseOnChange, formData, setFormData } = useForm(blog || initialStateValues)
  const { id } = useParams()

  const validateSlug = (slug: string) => {
    setSlugError(null)
    if (!slug) return
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(async () => {
      const exists = await checkSlugExists(slug)
      if (exists && slug !== blog?.slug) {
        setSlugError('Este slug ya existe')
      } else {
        setSlugError(null)
      }
    }, 500)
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any) => {
    const { name, value } = e.target
    if (name === 'slug') {
      setSlugManuallyEdited(true)
      const sanitized = value.toLowerCase().replace(/[^a-z0-9-]/g, '')
      setFormData(prev => ({ ...prev, slug: sanitized }))
      validateSlug(sanitized)
      return
    }
    if (name === 'titulo' && !slugManuallyEdited) {
      const newSlug = generateSlug(value)
      setFormData(prev => ({ ...prev, titulo: value, slug: newSlug }))
      validateSlug(newSlug)
      return
    }
    baseOnChange(e)
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault()

    if (slugError) return

    try {

      const currentSlug = slugManuallyEdited ? formData.slug : generateSlug(formData.titulo)
      const exists = await checkSlugExists(currentSlug)
      if (exists && currentSlug !== blog?.slug) {
        setSlugError('Este slug ya existe')
        return
      }

      if (!slugManuallyEdited) {
        formData.slug = currentSlug
      }

      if (isNewRegister(`${id}`)) {

        const blogRes = await addBlog(
          {
            ...formData,
            activo: true,
            fechaRegistro: new Date(),
          },
          images
        )

        setBlogs(prev => [...prev, blogRes])

        alert("Blog añadido")
        navigate('/blog')
      } else {
        const blogRes = await updateBlog(
          `${id}`,
          { ...formData },
          images
        )

        setBlogs(prev => prev.map(e => {
          if (e.id !== id) return e
          return { ...blogRes, id }
        }))
        alert("Blog actualizado")
        navigate('/blog')
      }

    } catch (e) {
      console.error(e)
    }

  }

  return {
    handleSubmit,
    onChange,
    formData,
    images,
    setImages,
    setFormData,
    slugError,
  }

}

export default useBlogAdd